<template>

  <div class="channel-select">
    <select
      class="form-control form-control-sm channel-select-input"
      :value="value"
      @change="$emit('input', $event.target.value)">
      <option
        v-for="channel in channels"
        :key="channel._id"
        :value="channel._id">
        {{ channelLabel(channel) }}
      </option>
    </select>
  </div>

</template>

<script>
export default {
  name: 'ChannelSelect',
  props: {
    channels: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    }
  },
  methods: {
    channelLabel (channel) {
      const integrationName = {
        whatsapp: 'WhatsApp'
      }
      return (integrationName[channel.integration] || channel.integration) + ' · ' + channel.name
    }
  }
}
</script>

<style scoped>
/* keep the channel select from stretching across the whole toolbar */
.channel-select-input {
  max-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/composer/ChannelSelect.vue